import { DialogContent, DialogOverlay } from '@reach/dialog'
import { useTranslation } from 'next-i18next'
import { FC, useState } from 'react'
import { Icon } from '~/elements/Icons/Icon'
import { Image } from '~/elements/Image/Image'

interface DetailsTableTencelRowProps {
  name: string
  label: string
}

export const DetailsTableTencelRow: FC<DetailsTableTencelRowProps> = ({ name, label }) => {
  const { t } = useTranslation()
  const [showDialog, setShowDialog] = useState(false)
  const open = () => setShowDialog(true)
  const close = () => setShowDialog(false)

  return (
    <>
      <p className="font-medium">{t(name)}</p>
      <div>
        <button className="text-left underline" onClick={open}>
          {label}
        </button>
        <DialogOverlay className="z-50 overflow-hidden" isOpen={showDialog} onDismiss={close}>
          <DialogContent className="h-5/6 w-5/6 overflow-y-auto p-8 md:h-auto md:w-1/2">
            <div className="relative col-span-2 gap-4 text-12-20-sg">
              <button
                className="close-button absolute top-0 right-0 z-50 grid h-10 w-10 place-items-center rounded-full bg-grey-light"
                onClick={close}
                aria-label="Close Popup"
              >
                <Icon name="cross" />
              </button>
              <div className="grid grid-cols-1 gap-4 pt-8 md:p-8 md:pl-0 lg:grid-cols-2">
                <div className="self-center">
                  <Image
                    src="/images/tencel_logo.png"
                    width={220}
                    height={150}
                    placeholder="empty"
                    alt="tencel_logo"
                    className="mx-auto my-0"
                  />
                </div>
                <div>
                  <div className="text-12-20-sg">
                    {t(
                      'TENCEL™ Lyocell fibers are obtained from cellulose that comes from sustainably managed forestry. A special solvent is used in the production process, which is almost completely recycled into the production cycle. This means that hardly any environmentally harmful by-products are produced. Lyocell is biodegradable and provides a touch of luxury in your home with its silky soft, shiny surface. TENCEL™ is a brand of Lenzing AG.',
                    )}
                  </div>
                  <div className="text-12-20-sg">
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t('You can find even more information about TENCEL™'),
                      }}
                    ></p>
                  </div>
                </div>
              </div>
            </div>
          </DialogContent>
        </DialogOverlay>
      </div>
    </>
  )
}
